import React from 'react'

const PageNotFound = () => {
  return (
    <div className="main-content">Page Not Found</div>
  )
}

export default PageNotFound